// Farren Foundation — palette controller + reveal observer
(function () {
  'use strict';
  if (window.__farrenFoundation) return;
  window.__farrenFoundation = true;

  // === Reveal on scroll observer ===
  function initReveal() {
    var els = document.querySelectorAll('.farren-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // === Palette controller (Anneler Günü default) ===
  // localStorage'dan palet hatırla (admin tweak için)
  function applyPalette() {
    try {
      var saved = localStorage.getItem('farren-palette');
      if (saved) document.documentElement.setAttribute('data-farren-palette', saved);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyPalette();
      initReveal();
    });
  } else {
    applyPalette();
    initReveal();
  }
})();
